import { UserContext } from "../../contexts/UserContext";

import { useContext, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import { Form } from "../../components/Form";
import WarningText from "../../components/Warnings";
import ButtonStyle from "../../components/Link";
import LogoStyle from "../../components/Logo";

import { loginSchema } from "../../services/schema/loginShema";

import { ContainerHome } from "./style";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export interface iLogin {
  email: string;
  password: string;
}

const HomePage = () => {
  const { navigate, userLogin } = useContext(UserContext);

  const [loadButton, setLoadButton] = useState(false);
  const [showPassword, setShowPassword] = useState("password");

  const login = (data: iLogin) => {
    userLogin(data, setLoadButton);
  };

    const modifyText = () => {
      showPassword === "password"
        ? setShowPassword("text")
        : setShowPassword("password");
    };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<iLogin>({
    resolver: yupResolver(loginSchema),
  });

  return (
    <>
      <ContainerHome>
        <LogoStyle>Kenzie Hub</LogoStyle>
      </ContainerHome>
      <Form onSubmit={handleSubmit(login)}>
        <h2>Login</h2>

        <div>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="text"
            placeholder="Digite seu email"
            {...register("email")}
          />
          <WarningText>{errors.email?.message}</WarningText>
        </div>

        <div>
          <label htmlFor="senha">Senha</label>
          <div className="inputPassword">
            <input
              id="senha"
              type={showPassword}
              placeholder="Digite sua senha"
              {...register("password")}
            />
            <button  type="button" className="showPassword" onClick={() => modifyText()}>
              {showPassword === "password" ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          <WarningText>{errors.password?.message}</WarningText>
        </div>

        <ButtonStyle type="submit" className="login" disabled={loadButton}>
          {loadButton ? "Carregando..." : "Entrar"}
        </ButtonStyle>

        <p>Ainda não possui uma conta?</p>

        <ButtonStyle
          type="button"
          className="redirect"
          onClick={() => navigate("/register")}
        >
          Cadastra-se
        </ButtonStyle>
      </Form>
    </>
  );
};

export default HomePage;
